module.exports = __webpack_public_path__ + "img/weddings_03_V.f4dd8904.webp";